export default {
  removeStorage() {
    localStorage.removeItem('userToken');
    localStorage.removeItem('userProfile');
    localStorage.removeItem('workUnits');
    localStorage.removeItem('currentWorkUnitId');
  },
};
